import { env } from "@/env";
import { isServer } from "@/paraglide/runtime";
import { configure } from "@bidbattles/bloks/config";
import { Result } from "@bidbattles/bloks/lib/result";
import { createServerFn, createServerOnlyFn } from "@tanstack/react-start";
import { getRequestHeader } from "@tanstack/react-start/server";
import { deleteToken__ServerOnly } from "./backend/auth";
import { API_URL, RT_HTTP_URL, RT_URL } from "./backend/constants";

const logout__ServerFn = createServerFn().handler(
	async (): Promise<Result<null, never>> => {
		deleteToken__ServerOnly();
		return Result.ok(null);
	},
);
const getCookie__ServerOnly = createServerOnlyFn(
	() => getRequestHeader("cookie") ?? null,
);

export function configureBloks() {
	configure({
		env: env.VITE_ENVIRONMENT,
		isServer,
		getCookie__ServerOnly,
		logout: logout__ServerFn,
		apiURL: Result.ok(API_URL),
		rtURL: Result.ok(RT_URL),
		rtHttpURL: Result.ok(RT_HTTP_URL),
	});
}
